import { useEffect, useState } from "react";

import { ITest } from "@/modules/assessments/types/test.interface";
import { TestHttpService } from "@/shared/services/tests/test-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";
import { notification } from "antd";

export function useGetAllTestsHook() {
  const [tests, setTests] = useState<ITest[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        setIsLoading(true);

        const tests: ITest[] = await TestHttpService.getAllTestsAsAdmin();
        setTests(tests);
      } catch (error) {
        const message = getFriendlyErrorMessage(error) ?? "Failed to load tests. Please try again.";
        notification.error({ message });
      } finally {
        setIsLoading(false);
      }
    };

    fetchTests();
  }, []);

  return { tests, isLoading };
}
